import { InputTypeEnum } from "~/app/forms/[form_id]/edit/types/common";

export const CALENDAR_LINK = "https://jl1zzmzlaee.typeform.com/to/oC8zpNzM";

export const FALLBACK_IMAGES = {
  PERSON_AVATAR: "/assets/images/user-fallback.svg",
  ORGANIZATION_AVATAR: "/assets/images/company-fallback.svg",
  ORGANIZATION_AVATAR_LIGHT: "/assets/images/company-fallback-light.svg",
};

export const REACT_QUERY_KEY = {
  HOMEPAGE_IP_COMPANY: "homepage-ip-company",
  HOMEPAGE_EVENTS_STATS: "homepage-events-stats",

  ONBOARDING_INFO: "onboarding-info",
  VERIFY_INVITATION_CODE: "verify-invitation-code",

  ORG_SCRIPT_API_KEY: "org-script-api-key",

  ORG_STAGES: "org-stages",
  ORG_STAGES_WITH_PIPELINE: "org-stages-with-pipeline",
  ORG_STAGE_BY_ID: "org-stage-by-id",
  ORG_STAGES_BY_PIPELINE_ID: "org-stages-by-pipeline-id",

  ORG_TEAM_MEMBERS: "org-team-members",
  ORG_OBJECT_VIEWS: "org-object-views",

  GMAIL_CONNECTION_QUERY_KEY: "gmail-connection-status",
  ALL_EMAILS_BY_USER: "all-emails-by-user",
  EMAILS_BY_THREAD_ID: "all-emails-by-thread-id",
  EMAILS_BY_COMPANY: "emails-by-company",
  EMAILS_BY_CONTACT: "emails-by-contact",
  EVENTS_BY_COMPANY: "events-by-company",

  IMMEDIATE_UPCOMING_EVENT_BY_USER: "immediate-upcoming-event-by-user",
  EMAIL_EVENT_COUNT_BY_COMPANY: "email-event-count-by-company",
  PAST_AND_UPCOMING_EVENTS: "past-and-upcoming-events",

  ORG_ATTRIBUTES: "org-attributes",
  ORG_ATTRIBUTES_BY_PROPERTY: "org-attributes-by-property",
  COMPANY_DATABASE: "company-database",
  SEARCH_ACCOUNT: "search-account",
  COMPANY_PAGE_DATA: "company-page-data",
  PEOPLE_DATABASE: "people-database",
  CONTACT_PAGE_DATA: "contact-page-data",
  SEARCH_CONTACT: "search-contact",
  SELECT_ATTRIBUTE_OPTIONS: "select-attribute-options",

  ACCOUNT_BY_DOMAIN: "account-by-domain",

  ACCOUNT_CONTACTS: "account-contacts",

  CHECK_ORG_VISITORS: "check-org-visitors",
  GET_ORG_VISITORS: "get-org-visitors",
  GET_ORG_VISITORS_COMPANY_INFO: "get-org-visitors-company-info",
  GET_ORG_VISITORS_SEARCHED_COMPANIES: "get-org-visitors-searched-companies",
  GET_ORG_VISITED_PAGES: "get-org-visited-pages",
  GET_ORG_ALL_VIEWED_PAGES: "get-org-all-viewed-pages",

  ORG_FEATURE_FLAGS: "org-feature-flags",
  ORG_FEATURE_USAGE: "org-feature-usage",

  SEARCH_COPILOT: "search-copilot",

  GET_CUSTOM_LIST: "get-custom-list",
  GET_CUSTOM_LIST_BY_ID: "get-custom-list-by-id",
  GET_CUSTOM_LIST_VIEW_BY_ID: "get-custom-list-view-by-id",

  GET_ORG_FORMS: "get-org-forms",
  GET_ORG_FORM_DATA: "get-org-form-data",
  GET_FORM_RESPONSES: "get-form-responses",
  GET_FORM_FIELDS_BY_FORM_ID: "get-form-fields-by-form-id",
  OBJECT_FORM_MAPPED_DATA: "object-form-mapped-data",

  ALL_OPPORTUNITIES_LISTS: "all-opportunities-lists",
  ALL_OPPORTUNITIES_LISTS_BY_STAGE: "all-opportunities-lists-by-stage",
  OPPORTUNITY_BY_ID: "opportunity-by-id",
  OPPORTUNITY_ATTRIBUTES: "opportunity-attributes",

  GLOBAL_NOTES: "global-notes",
  NOTE_DATA_BY_ID: "note-data-by-id",
  NOTE_DATA_BY_ENTITY_ID: "note-data-by-entity-id",
  ACCOUNT_NOTES: "account-notes",
  CONTACT_NOTES: "contact-notes",
  CONTACT_ACTIVITIES: "contact-activities",
  ACCOUNT_ACTIVITIES: "account-activities",
  OPPORTUNITY_NOTES: "opportunity-notes",

  GLOBAL_TASKS: "global-tasks",
  OPPORTUNITY_TASKS: "opportunity-tasks",

  OPPORTUNITY_SUMMARY_COUNT: "opportunity-summary-count",
  OPPORTUNITY_HIGHLIGHTS: "opportunity-highlights",
  OPPORTUNITY_EMAILS: "opportunity-emails",
  OPPORTUNITY_ACCOUNT_CONTACTS: "opportunity-account-contacts",
  OPPORTUNITIES_BY_OBJECT: "opportunities-by-object",
  OPPORTUNITY_PIPELINE_VIEWS: "opportunity-pipeline-views",
  OPPORTUNITY_PIPELINES_WITH_VIEWS: "opportunity-pipelines-with-views",
  OPPORTUNITY_STAGE_WISE_DEAL_SIZE: "opportunity-stage-wise-deal-size",
  CONTACT_PAGE_OPPORTUNITY_DATA: "contact-page-opportunity-data",
  ACCOUNT_PAGE_OPPORTUNITY_DATA: "account-page-opportunity-data",
  OPPORTUNITY_PAGE_DATA: "opportunity-page-data",
  EMAIL_FINDER_BULK_UPLOAD_LIST: "email-finder-bulk-upload-list",

  OPPORTUNITY_ATTR_RECORD_DATA: "opportunity-attr-record-data",

  PIPELINES_OPPORTUNITY_CREATE: "pipelines-opportunity-create",
  PIPELINE_LAST_OPPORTUNITY_CREATED: "pipeline-last-opportunity-created",

  ORG_MEMBERS: "org-members",
  SEARCH_ORG_OBJECTS: "search-org-objects",
  ADMIN_ALL_USERS: "admin-all-users",

  DASHBOARD_UNIQUE_VISITORS_COUNT: "dashboard-unique-visitors-count",
  DASHBOARD_UNIQUE_VISITORS_CHART_DATA: "dashboard-unique-visitors-chart-data",
  DASHBOARD_OPPORTUNITY_STATS: "dashboard-opportunity-stats",
  OPPORTUNITY_PIPELINES: "opportunity-pipelines",

  SUMMARIZE_EMAILS: "summarize-emails",
  CONTACTS_DATA_BY_IDS: "contacts-data-by-ids",
  GET_CONNECTED_GMAILS: "get-connected-gmails",
  DRAFT_EMAILS: "draft-emails",
  SCHEDULED_EMAILS: "scheduled-emails",
  SYNC_RECIPIENTS: "sync-recipients",

  CHECK_HAS_OLD_PASSWORD: "check-has-old-password",

  WORKFLOWS_PAGE_LIST: "workflows-page-list",
  WORKFLOW_DETAILS_PAGE: "workflow-details-page",
  WORKFLOW_DETAILS_PAGE_ACTIVITIES: "workflow-details-page-activities",

  GET_API_KEY_BY_TYPE: "get-api-key-by-type",

  ALL_EMAIL_CAMPAIGNS: "all-email-campaigns",
  EMAIL_CAMPAIGN_BY_ID: "email-campaign-by-id",
  EMAIL_CAMPAIGN_SEQUENCES: "email-campaign-sequences",
  CAMPAIGN_SETTINGS: "campaign-settings",
  ORG_CAMPAIGN_SETTINGS: "org-campaign-settings",

  CAMPAIGN_LEADS: "campaign-leads",
  GMAIL_ACCOUNTS: "gmail-accounts",
  CAMPAIGN_MAIL_PROVIDERS: "campaign-mail-providers",
  CONNECT_SLACK_WORKSPACE: "connect-slack-workspace",
  SLACK_WORKSPACES: "slack-workspaces",
  SLACK_ALL_CHANNELS: "slack-all-channels",
  SLACK_WORKSPACE_CHANNELS: "slack-workspace-channels",
  CHECK_BOT_ACCESS_TO_CHANNEL: "check-bot-access-to-channel",

  MEETINGS_PAGE_DATA_BY_TYPE: "meetings-page-data-by-type",
  MEETINGS_RECORDINGS_PAGE_DATA: "meetings-recordings-page-data",
  MEETING_PAGE_DATA_BY_ID: "meeting-page-data-by-id",
  MEETINGS_TRANSCRIPT_PAGE_DATA: "meetings-transcript-page-data",
  MEETINGS_PREFERENCE: "meetings-preference",
  MEETINGS_FOR_NEXT_24_HOURS: "meetings-for-next-24-hours",
  MEETING_PAGE_ATTENDEES: "meeting-page-attendees",
  MEETING_RECORDING_SETTINGS: "meeting-recording-settings",

  CONNECT_STRIPE_ACCOUNT: "connect-stripe-account",
  CIRCLEBACK_WEBHOOK_STATUS: "circleback-webhook-status",
  STRIPE_ACCOUNT_CONNECTION_STATUS: "stripe-account-connection-status",

  SALES_APP_NAVBAR_ITEMS: "sales-app-navbar-items",
  COMMANDBAR_SEARCH_COMMANDS: "commandbar-search-commands",
  COMMANDBAR_SEARCH_PAGES: "commandbar-search-pages",
  COMMANDBAR_SEARCH_RECORDS: "commandbar-search-records",

  AI_ACTION_DATA: "ai-action-data",
  GLOBAL_SEARCH: "global-search",
  GLOBAL_SEARCH_BY_OBJECT_TYPE: "global-search-by-object-type",
  FILES_MANAGEMENT_FILES_FOLDERS: "files-management-files-folders",
  FILES_MANAGEMENT_FILES_COUNT: "files-management-files-count",
  FAVORITES: "favorites",

  REPORTING_DASHBOARD_NUMERIC: "reporting-dashboard-numeric",
  REPORTING_DASHBOARD_CHART: "reporting-dashboard-chart",
  RECENTLY_VIEWED: "recently-viewed",
  USER_SESSION: "user-session",

  PIPELINE_TEMPLATES: "pipeline-templates",
  PIPELINES_WITH_STAGES: "pipelines-with-stages",
  PIPELINE_STAGE_DEAL_STATS: "pipeline-stage-deal-stats",

  // Integrations
  INTEGRATION_ALL: "integration-all",
  INTEGRATION_BY_SERVICE: "integration-by-service",

  // Docusign
  DOCUSIGN_FOLDERS: "docusign-folders",
  DOCUSIGN_ENVELOPES: "docusign-envelopes",
  DOCUSIGN_ENVELOPE: "docusign-envelope",
  DOCUSIGN_ENVELOPE_RECIPIENTS: "docusign-envelope-recipients",
  DOCUSIGN_ENVELOPE_DOCUMENTS: "docusign-envelope-documents",
  DOCUSIGN_ENVELOPE_FOLDERS: "docusign-envelope-folders",

  // Slack
  SLACK_WORKSPACE: "slack-workspace",

  // Subscription
  SUBSCRIPTION: "subscription",
  SUBSCRIPTION_USAGE: "subscription-usage",
  SUBSCRIPTION_CHECKOUT: "subscription-checkout",
  SUBSCRIPTION_INVOICES: "subscription-invoices",
  SUBSCRIPTION_INVOICE_BY_ID: "subscription-invoice-by-id",
  SUBSCRIPTION_CUSTOMER_PORTAL_URL: "subscription-customer-portal-url",
  // Google Calendar
  GOOGLE_CALENDAR_CONNECTION_STATUS: "google-calendar-connection-status",
  GOOGLE_CALENDAR_EVENTS: "google-calendar-events",
  GOOGLE_CALENDAR_EVENTS_BY_ACCOUNT: "google-calendar-events-by-account",
  GET_CONNECTED_GOOGLE_CALENDARS: "get-connected-google-calendars",
} as const;

export const RIGHT_SIDEBAR_MINIMUM_WIDTH = 10;
export const RIGHT_SIDEBAR_DEFAULT_WIDTH = 30;
export const MAIN_CONTENT_MINIMUN_WIDTH = 50;
export const RIGHT_SIDEBAR_KEY = "opened_right_sidebars";
export const ADD_NEW_PIPELINE = "ADD_NEW_PIPELINE" as const;

export const OBJECT_TYPE = {
  ACCOUNT: "account",
  CONTACT: "contact",
  NOTE: "note",
  TASK: "task",
  VISITOR: "visitor",
  OPPORTUNITY: "opportunity",
} as const;

export const ADD_NEW_VIEW = "ADD_VIEW" as const;
export const FORM_INPUT_TYPES = Object.values(InputTypeEnum);

export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  UUID: /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-4[0-9a-fA-F]{3}\-(8|9|a|b|A|B)[0-9a-fA-F]{3}\-[0-9a-fA-F]{12}$/,
  CURRENCY_FORMAT: /[^0-9kmb.]/gi,
  DOMAIN: /^[a-z0-9.-]+\.[a-z]{2,}$/,
};
